<template>
  <div class="wrap myoreders-wrap personal-wrap flex-column">
    <!-- 搜索框 -->
    <div class="input-box flex-row">
      <!-- <input class="serarch-input" type="text" name="" placeholder="搜索线下订单" v-model="queryText" :autofocus="true" > -->
      <div class="search-box flex-item flex-row">
        <span>CP -</span>
        <input
          @keyup="checkNum($event, 'orderNumFour')"
          v-model="orderNumObj.orderNumFour"
          placeholder="数字"
          class="flex-item"
          type="text"
          name=""
        />
        <span>-</span>
        <input
          @keyup="checkNum($event, 'orderNumFour')"
          v-model="orderNumObj.orderNumFive"
          placeholder="数字"
          class="flex-item"
          type="text"
          name=""
        />
      </div>
      <span class="search-btn blue" @click="searchOrder()">搜索</span>
    </div>
    <div class="search-tips">
      请在上方线框空白处填写CP订单号，进行快速自助查询，美心祝您购物愉快。全国服务热线：400-832-2777
    </div>

    <mu-infinite-scroll
      :loading="loadShow"
      loadingText="拼命加载中"
      class="load"
      v-if="loadShow"
    />
    <div class="orderDetail flex-item" v-else>
      <!-- <div class="empty" v-if="isEmpty">暂无信息</div> -->
      <empty
        imgpath="/static/images/empty_orders_3x.png"
        emptytext="暂无记录"
        v-if="isEmpty"
      ></empty>
      <div v-if="orderContent.length > 0">
        <div class="title flex-row">
          <div class="flex-item">查询结果</div>
          <div class="title-tip">
            本数据由
            <a>重庆美心集团</a>
            提供
          </div>
        </div>
        <div class="flex-row order-title">
          <div class="flex-item">
            订单：CP-{{ orderNumObj.orderNumFour }}-{{
              orderNumObj.orderNumFive
            }}
          </div>
          <div class="order-title-tip">我的订单列表</div>
        </div>
        <ul class="orderLists">
          <li class="timeImg"></li>
          <li v-for="item in orderContent" class="order-item flex-item">
            {{ item.recTime }}&nbsp;&nbsp;{{ item.recDesc }}
          </li>
        </ul>
      </div>
      <!-- <div class="content" v-if="!isEmpty" v-html="orderContent"></div> -->
    </div>
    <div class="bottom-img">
      <img src="./imgs/logo_meixin2_3x.png" />
    </div>
    <!--  <empty imgpath="/static/images/empty_orders_3x.png" emptytext="您还没有相关订单" btntext="去逛一逛" btnurl="/main/home" v-if="pageMemOrderList.length==0 && !loadShow"></empty>
 -->
    <mu-toast
      v-if="toast.isShow"
      :message="toast.messageTip"
      class="custom-toast"
    />
  </div>
</template>
<script type="text/javascript">
import imgs from "@components/image/image";
import myOrdersItem from "@components/myOrdersItem/myOrdersItem";
import empty from "@components/empty/empty";
import { mapActions, mapGetters } from "vuex";
import { storage } from "@common/utils/util.js";
import util from "@common/utils/util.js";
export default {
  data() {
    return {
      queryText: "",
      orderContent: [],
      isEmpty: false,
      loadShow: false,
      toast: {
        isShow: false,
        messageTip: "",
      },
      orderNumObj: {
        orderNumFour: null,
        orderNumFive: null,
      },
    };
  },
  mounted() {},
  watch: {
    orderContent() {
      if (this.orderContent && this.orderContent.length > 0) {
        this.isEmpty = false;
        return;
      }
      this.isEmpty = true;
    },
  },
  methods: {
    ...mapActions({
      queryOrder: "queryOrder", //线下订单查询
    }),
    showTipMessage(isShow, msg) {
      this.toast.isShow = isShow;
      this.toast.messageTip = msg;
      setTimeout(() => {
        this.toast.isShow = false;
      }, 500);
    },
    searchOrder() {
      if (!this.orderNumObj.orderNumFive && !this.orderNumObj.orderNumFour) {
        this.showTipMessage(true, "请输入关键字");
        return;
      }
      this.queryText =
        "CP-" +
        (this.orderNumObj.orderNumFour || "") +
        "-" +
        (this.orderNumObj.orderNumFive || "");
      // if (this.queryText == '') {
      //   this.showTipMessage(true,'请输入关键字');
      //   return
      // }
      this.loadShow = true;
      this.queryOrder(this.queryText)
        .then((res) => {
          this.orderContent = res.recs;
          this.loadShow = false;
        })
        .catch((error) => {
          this.showTipMessage(true, error || "搜索失败,请稍后重试");
        });
    },
    checkNum(e, name) {
      if (!util.isNum(e.key)) {
        let obj = Object.assign({}, this.orderNumObj);
        let str = obj[name].replace(e.key, "");
        this.orderNumObj[name] = str;
      }
    },
  },
  created() {},
  components: {
    imgs,
    myOrdersItem,
    empty,
  },
};
</script>
<style lang="scss" rel="stylesheet/scss">
@import "personal.scss";
.myoreders-wrap {
  .search-box {
    margin: 0 0.2rem;
    padding: 0 1.093333rem 0 1.773333rem;
    @include font-dpr(16px);
    background: url(/static/images/productList_search@3x.png) no-repeat 0.3rem
      center;
    background-size: 0.45rem;
    background-color: #efefef;
    height: 0.7rem;
    line-height: 0.7rem;
    border-radius: 0.675rem;
    > input {
      background: transparent;
      padding-left: 0.2rem;
    }
  }
  .search-tips {
    @include font-dpr(12px);
    color: #858484;
    background: #efefef;
    padding: 0.2rem 0.266667rem;
    word-break: break-all;
    text-align: justify;
    line-height: 1.5;
  }
  .input-box {
    width: 100%;
    padding: 0.3rem 0;
    background: #fff;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.09);
    z-index: 2;
    text-align: center;
    .serarch-input {
      display: inline-block;
      width: 80%;
      height: 0.7rem;
      margin: 0 auto;
      border-radius: 0.675rem;
      @include sInput(#efefef, center, #999999);
      background: url(/static/images/productList_search@3x.png) no-repeat
        0.25rem center;
      background-size: 0.45rem;
      background-color: #efefef;
    }
    .search-btn {
      display: inline-block;
      padding: 0 0.25rem;
      @include font-dpr(14px);
      color: #666666;
      line-height: 0.7rem;
    }
    .search-btn.blue {
      color: #4a90e2;
    }
  }
  .orderDetail {
    background: #fff;
    padding: 0.213333rem 0.186667rem;
    @include font-dpr(16px);
    .title {
      margin-bottom: 0.213333rem;
      color: #999999;
      @include font-dpr(14px);
      .title-tip {
        @include font-dpr(11px);
        color: #000;
        font-weight: 600;
        a {
          color: #1f86ff;
        }
      }
    }
    .content {
      padding: 0.093333rem 0;
      color: #fd7b00;
    }
  }
  .order-title {
    padding: 0.266667rem 0;
    color: #fd7b00;
  }
  .order-title-tip {
    @include font-dpr(12px);
  }
  .orderLists {
    padding: 0 0.4rem;
    .timeImg {
      position: relative;
      line-height: 0;
      &:before {
        content: "";
        display: inline-block;
        width: 0.426667rem;
        height: 0.426667rem;
        background: url(./imgs/time_3x.png) no-repeat;
        background-size: 100%;
        left: -0.2rem;
      }
    }
    .order-item {
      position: relative;
      padding: 0.426667rem 0.4rem 0.266667rem 0.533333rem;
      color: #fd7b00;
      @include font-dpr(13px);
      &:before {
        content: "";
        display: inline-block;
        position: absolute;
        width: 0.186667rem;
        height: 0.186667rem;
        border-radius: 50%;
        background: #fd7b00;
        top: 0.463333rem;
        left: 0.096667rem;
      }
      &:after {
        content: "";
        display: inline-block;
        width: 1px;
        position: absolute;
        top: -0.036667rem;
        left: 0.18rem;
        bottom: 0;
        background: #fd7b00;
      }
      &:last-child {
        &:after {
          bottom: 0.466667rem;
        }
      }
    }
  }
  .bottom-img {
    text-align: center;
    border-bottom: 0.213333rem solid #ffd500;
    img {
      width: 3.32rem;
      margin-top: 0.24rem;
      margin-bottom: 0.106667rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// searchbeloworders.vue?184c6ad8